import Barba from 'barba.js'
import { TweenLite } from 'gsap/TweenLite'

export default Barba.BaseTransition.extend({
    start() {
        console.log( 'homepage theme transition' );
        this.newContainerLoading.then(this.animate.bind(this));
    },
    animate() {
        let self = this;
        Barba.Pjax.Manager.getAnimationManager().get('homepageThemeOut').onCompleteCallback( (timeline, animation)  => {
            let loader = document.createElement('div');
            loader.style.backgroundColor = getComputedStyle( animation.element.querySelector('.background') ).backgroundColor;
            loader.style.position = 'fixed';
            loader.style.top = '0';
            loader.style.left = '0';
            loader.style.width = '100%';
            loader.style.height = '100%';
            loader.style.zIndex = '9999';
            loader.classList.add('temp-loader');
            document.querySelector('#app').append(loader)
            this.finish()
        }, self).play();
    },
    finish() {
        document.body.scrollTop = 0;
        this.done();
        let loader = document.querySelector('.temp-loader');
        TweenLite.to( document.querySelector('.temp-loader'), .25, {
            opacity: 0,
            onComplete( loader) {
                loader.remove()
            },
            onCompleteParams: [loader]
        } )

    }
})